// extracted by mini-css-extract-plugin
module.exports = {"ErrorScreen":"Error_ErrorScreen__2Dnkv","ErrorMessage":"Error_ErrorMessage__3FnD_","RestartTitle":"Error_RestartTitle__w8vew"};